import { createSelector } from 'reselect';

const selectCompanyClaimRestrictionsState = state => state.system.companyClaimRestrictions;

export const selectCompanyClaimRestrictions = createSelector(
  selectCompanyClaimRestrictionsState,
  state => state.data,
);
